import { render, staticRenderFns } from "./statementAccount.vue?vue&type=template&id=63f329ef&scoped=true"
import script from "./statementAccount.vue?vue&type=script&lang=js"
export * from "./statementAccount.vue?vue&type=script&lang=js"
import style0 from "./statementAccount.vue?vue&type=style&index=0&id=63f329ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f329ef",
  null
  
)

export default component.exports